<template>
  <span class="operation-tool-label">
    <ProductIcon
      v-if="product"
      :product="product"
      class="operation-tool-label__icon"
      alt=""
      aria-hidden="true"
    />
    <i
      v-else
      class="fa-solid fa-file operation-tool-label__fallback"
      aria-hidden="true"
    ></i>
    <span>{{ label }}</span>
  </span>
</template>

<script>
import ProductIcon from "@/components/ProductIcon.vue";

export default {
  name: "OperationToolLabel",
  components: { ProductIcon },
  props: {
    operation: {
      type: String,
      default: "",
    },
  },
  computed: {
    product() {
      const operation = this.operation.toLowerCase();
      if (operation.includes("prospett")) return "prospetti";
      if (operation.includes("f24")) return "f24";
      if (operation.includes("bilancio")) return "bilancio";
      return "";
    },
    label() {
      const labels = {
        prospetti: "Prospetto Paghe",
        f24: "Modello F24",
        bilancio: "Bilancio Analitico",
      };

      return (
        labels[this.product] ||
        this.operation.replace(/^Conversione\s+/i, "") ||
        "Strumento"
      );
    },
  },
};
</script>

<style scoped>
.operation-tool-label {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.55rem;
  color: #24384d;
  font-size: 0.82rem;
  font-weight: 650;
  line-height: 1.2;
  text-align: left;
}

.operation-tool-label__icon {
  width: 2rem;
  height: 2rem;
  flex: 0 0 2rem;
}

.operation-tool-label__fallback {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  flex: 0 0 2rem;
  align-items: center;
  justify-content: center;
  color: #65788b;
  font-size: 1rem;
}
</style>
